import { useInternalTableDndSortable } from "../InternalTableDnd/hooks/useInternalTableDndSortable";
import { getCommonPinningStyles } from "../InternalTableHeader/InternalTableHeaderPinner/InternalTableHeaderPinner.utils";
import { CSS } from "../InternalTableDnd/InternalTableDnd.utils";

import { flexRender } from "../utils/render";

import { EXPAND_ROW_COLUMN_ID, SELECT_ROW_COLUMN_ID } from "../Table.constants";

import type { Header } from "../Table.types";

import tableStyles from "../Table.module.css";
import { classNames } from "@certa/catalyst/utils/common";

type InternalTableFooterProps<TableData> = {
  header: Header<TableData, unknown>;
};

export const InternalTableFooter = <TableData extends Record<string, any>>(
  props: InternalTableFooterProps<TableData>
) => {
  const { header } = props;

  const { isDragging, setNodeRef, transform, transition } =
    useInternalTableDndSortable(header.column);

  const columnPinningStyles = getCommonPinningStyles(header.column);

  const isResizing = header.column.getIsResizing();

  return (
    <td
      key={header.id}
      ref={setNodeRef}
      className={classNames({
        [tableStyles.tableCell]: true,
        [tableStyles.tableCellDragging]: isDragging,
        [tableStyles.tableCellResizing]: isResizing
      })}
      style={{
        opacity: isDragging ? 0.8 : 1,
        position: "relative",
        // translate instead of transform to avoid squishing
        transform: CSS.Translate.toString(transform),
        transition: transition ?? "",
        width: header.column.getSize(),
        ...columnPinningStyles,
        boxShadow: [SELECT_ROW_COLUMN_ID, EXPAND_ROW_COLUMN_ID].includes(
          header.column.id
        )
          ? "none"
          : columnPinningStyles.boxShadow,
        zIndex: isDragging ? 1 : columnPinningStyles.zIndex
      }}
    >
      {flexRender(header.column.columnDef.footer, header.getContext())}
    </td>
  );
};
